import React, { useEffect, useMemo, useState } from "react"
import { socket } from "../../io"

export const TicketsNextRun = () => {
  const [tickets, setTickets] = useState([])
  const [search, setSearch] = useState("")
  const [sortConfig, setSortConfig] = useState({
    key: "num",
    direction: "asc",
  })

  useEffect(() => {
    const NewTicket = (tk) => {
      console.log("new-ticket =>", tk)

      if (Array.isArray(tk)) {
        setTickets(tk)
        return
      }

      if (tk && typeof tk === "object") {
        setTickets((prev) => [...prev, tk])
      }
    }

    socket.on("new-ticket", NewTicket)

    return () => {
      socket.off("new-ticket", NewTicket)
    }
  }, [])

  const formatCellValue = (value) => {
    if (value === null || value === undefined) return ""

    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
      return String(value)
    }

    if (Array.isArray(value)) {
      return value
        .map((item) => {
          if (item === null || item === undefined) return ""
          if (typeof item === "string" || typeof item === "number" || typeof item === "boolean") {
            return String(item)
          }
          if (typeof item === "object") {
            if (item.name) return String(item.name)
            if (item.title) return String(item.title)
            if (item.code) return String(item.code)
            if (item.number) return String(item.number)
            return JSON.stringify(item)
          }
          return String(item)
        })
        .join(", ")
    }

    if (typeof value === "object") {
      if (value.name) return String(value.name)
      if (value.title) return String(value.title)
      if (value.code) return String(value.code)
      if (value.number) return String(value.number)
      if (value.username) return String(value.username)
      if (value._id) return String(value._id)

      return JSON.stringify(value)
    }

    return String(value)
  }

  const rows = useMemo(() => {
    return tickets.map((tk, index) => {
      const dogsValue = tk?.dog ?? tk?.dogs ?? ""
      const amountValue = tk?.betted ?? tk?.amount ?? tk?.bet ?? ""
      const winValue = tk?.win ?? tk?.prize ?? tk?.payout ?? ""
      const pointValue = tk?.point ?? tk?.points ?? ""

      return {
        original: tk,
        key: tk?._id || `${index}-${Math.random()}`,
        num: index + 1,
        dogs: formatCellValue(dogsValue),
        amount: formatCellValue(amountValue),
        points: formatCellValue(pointValue),
        win: formatCellValue(winValue),
      }
    })
  }, [tickets])

  const filteredAndSortedRows = useMemo(() => {
    let result = [...rows]

    const q = search.trim().toLowerCase()

    if (q) {
      result = result.filter((row) => {
        return (
          String(row.num).toLowerCase().includes(q) ||
          String(row.dogs).toLowerCase().includes(q) ||
          String(row.amount).toLowerCase().includes(q) ||
          String(row.points).toLowerCase().includes(q) ||
          String(row.win).toLowerCase().includes(q)
        )
      })
    }

    result.sort((a, b) => {
      const aValue = a[sortConfig.key] ?? ""
      const bValue = b[sortConfig.key] ?? ""

      const aNum = Number(aValue)
      const bNum = Number(bValue)

      let comparison = 0

      if (!Number.isNaN(aNum) && !Number.isNaN(bNum) && aValue !== "" && bValue !== "") {
        comparison = aNum - bNum
      } else {
        comparison = String(aValue).localeCompare(String(bValue), undefined, {
          numeric: true,
          sensitivity: "base",
        })
      }

      return sortConfig.direction === "asc" ? comparison : -comparison
    })

    return result
  }, [rows, search, sortConfig])

  const requestSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === "asc" ? "desc" : "asc",
        }
      }

      return {
        key,
        direction: "asc",
      }
    })
  }

  const getSortIndicator = (key) => {
    if (sortConfig.key !== key) return "⇅"
    return sortConfig.direction === "asc" ? "↑" : "↓"
  }

  return (
    <div style={{ padding: "16px" }}>
      <div
        style={{
          fontSize: "20px",
          fontWeight: "700",
          marginBottom: "12px",
          color: "#fff",
        }}
      >
        Tickets para la Próxima carrera
      </div>

      <div style={{ marginBottom: "12px" }}>
        <input
          type="text"
          placeholder="Filtrar por cualquier campo..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            width: "100%",
            maxWidth: "420px",
            padding: "10px 12px",
            borderRadius: "8px",
            border: "1px solid #444",
            outline: "none",
            background: "#111",
            color: "#fff",
          }}
        />
      </div>

      <div style={{ overflowX: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            background: "#121212",
            color: "#fff",
          }}
        >
          <thead>
            <tr style={{ background: "#1d1d1d" }}>
              <th style={thStyle} onClick={() => requestSort("num")}>
                Num {getSortIndicator("num")}
              </th>
              <th style={thStyle} onClick={() => requestSort("dogs")}>
                Dogs {getSortIndicator("dogs")}
              </th>
              <th style={thStyle} onClick={() => requestSort("amount")}>
                Amount {getSortIndicator("amount")}
              </th>
              <th style={thStyle} onClick={() => requestSort("win")}>
                Win {getSortIndicator("win")}
              </th>
              <th style={thStyle} onClick={() => requestSort("points")}>
                Points {getSortIndicator("points")}
              </th>
              <th style={thStyle}>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredAndSortedRows.length > 0 ? (
              filteredAndSortedRows.map((row) => (
                <tr key={row.key} style={{ borderBottom: "1px solid #2d2d2d" }}>
                  <td style={tdStyle}>{row.num}</td>
                  <td style={tdStyle}>{row.dogs}</td>
                  <td style={tdStyle}>{row.amount}</td>
                  <td style={tdStyle}>{parseInt(row.win)}</td>
                  <td style={tdStyle}>{row.points}</td>
                  <td style={tdStyle}>
                    <button
                      style={{
                        background: "#2563eb",
                        color: "#fff",
                        border: "none",
                        padding: "6px 10px",
                        borderRadius: "6px",
                        cursor: "pointer",
                      }}
                    >
                      ?
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td style={tdStyle} colSpan={6}>
                  No hay tickets para mostrar
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const thStyle = {
  padding: "12px",
  textAlign: "left",
  borderBottom: "1px solid #333",
  cursor: "pointer",
  userSelect: "none",
  whiteSpace: "nowrap",
}

const tdStyle = {
  padding: "12px",
  textAlign: "left",
  whiteSpace: "nowrap",
}